import { TbReportSearch } from "react-icons/tb";
import { AiFillSignal } from "react-icons/ai";
import { AiFillFilePdf } from "react-icons/ai";
import { BiUserPlus } from "react-icons/bi";
import { BiSolidReport } from "react-icons/bi";
import { FaRegFileArchive /*FaUsersCog*/ } from "react-icons/fa";
import { IoNotificationsCircleSharp } from "react-icons/io5";
import { TbTableOptions } from "react-icons/tb";
import { Link } from "react-router-dom";
import { HeaderIndex, FooterIndex } from "../../components/";
import "./index.css";

const HomePageL = () => {
  return (
    <div>
      <HeaderIndex />
      <div className="container-botton-lealtad">
        <div className="container-flex-buttons-lealtad">
          <Link to="/lealtad/informe">
            <div className="buttons-index-lealtad">
              <div className="container-text-icons-lealtad">
                <TbReportSearch className="icon-button-lealtad" />
                <p className="text-button-lealtad" id="informe-lealtad">
                  Informe
                </p>
              </div>
            </div>
          </Link>

          <Link to="/lealtad/detailMDR">
            <div className="buttons-index-lealtad">
              <div className="container-text-icons-lealtad">
                <AiFillSignal className="icon-button-lealtad" />
                <p className="text-button-lealtad">Matriz de Riesgo</p>
              </div>
            </div>
          </Link>

          {/*<Link to="/lealtad/cargar-proveedores">
            <div className="buttons-index-lealtad">
              <div className="container-text-icons-lealtad">
                <FaUsersCog className="icon-button-lealtad" />
                <p className="text-button-lealtad">Cargar Proveedor</p>
              </div>
            </div>
          </Link>*/}

          <Link to="/lealtad/cargar">
            <div className="buttons-index-lealtad">
              <div className="container-text-icons-lealtad">
                <FaRegFileArchive className="icon-button-lealtad" />
                <p className="text-button-lealtad">Cargar Archivo</p>
              </div>
            </div>
          </Link>

          <Link to="/lealtad/crear-relacion">
            <div className="buttons-index-lealtad">
              <div className="container-text-icons-lealtad">
                <BiUserPlus className="icon-button-lealtad" />
                <p className="text-button-lealtad">Crear Relación</p>
              </div>
            </div>
          </Link>

          <Link to="/lealtad/alertas">
            <div className="buttons-index-lealtad">
              <div className="container-text-icons-lealtad">
                <IoNotificationsCircleSharp className="icon-button-lealtad" />
                <p className="text-button-lealtad">Alertas</p>
              </div>
            </div>
          </Link>

          <Link to="/lealtad/edit-matriz">
            <div className="buttons-index-lealtad">
              <div className="container-text-icons-lealtad">
                <TbTableOptions className="icon-button-lealtad" />
                <p className="text-button-lealtad">Variables de Matriz</p>
              </div>
            </div>
          </Link>

          <Link to="/lealtad/reportes">
            <div className="buttons-index-lealtad">
              <div className="container-text-icons-lealtad">
                <BiSolidReport className="icon-button-lealtad" />
                <p className="text-button-lealtad">Reportes</p>
              </div>
            </div>
          </Link>
          <Link to="/lealtad/Legajos">
            <div className="buttons-index-lealtad">
              <div className="container-text-icons-lealtad">
                <AiFillFilePdf className="icon-button-lealtad" />
                <p className="text-button-lealtad">Legajos</p>
              </div>
            </div>
          </Link>
        </div>
        <FooterIndex />
      </div>
    </div>
  );
};

export default HomePageL;
